import { useCookies } from "components/store/source";

import { partnerReferralCookieName } from "pages/partners/types";

interface ReturnType {
  referralPartnerId: string | null;
}
export const useReferralPartnerId = (): ReturnType => {
  const { getCookie } = useCookies();

  const referralPartnerId = getCookie(
    partnerReferralCookieName,
  ) as unknown as string;

  return {
    referralPartnerId: referralPartnerId ?? null,
  };
};
